export const MOBILE_NAV_ACTIVE_COLOR = 'var(--membership-ice-pink, #ff4286)';
export const MOBILE_NAV_INACTIVE_COLOR = '#515151';

const firstChar = (value) => {
  const t = String(value ?? '').trim();
  return t ? t.charAt(0).toUpperCase() : '';
};

export const getAccountTabInitial = (user, userData) => (
  firstChar(userData?.firstName)
  || firstChar(user?.displayName?.split(/\s+/)[0])
  || firstChar(user?.displayName)
  || firstChar(user?.email)
  || firstChar(userData?.email)
  || ''
);
